;(function () {
  'use strict'

  angular
    .module('contrast.attacks')
    .controller(
      'AttackOverviewCtrl',
      function AttackOverviewCtrl(
        $scope,
        $rootScope,
        $routeParams,
        $uibModal,
        $location,
        $q,
        AttackFactory,
        AttackEventsFactory,
        TagFactory,
        UserService,
        ErrorService,
        AttackSearchService,
        IPBlacklistModalService,
        csTemplates,
        dialogs,
        logger,
        ATTACK_STATUS,
        ATTACK_DISCUSSION_EVENTS
      ) {
        'ngInject'

        var attackUuid = $routeParams.attackUuid

        angular.extend($scope, {
          busy: false,
          isSticky: true,
          show_timeline: false,
          routes: [
            { label: 'Overview', value: 'summary' },
            { label: 'Notes', value: 'notes' },
            { label: 'Discussion', value: 'discussion' }
          ],
          model: {
            active: 'summary',
            attack: undefined,
            environments: [],
            count: 0,
            previous: undefined,
            next: undefined,
            index: 0,
            attack_status: ATTACK_STATUS,
            discussionCount: {
              total: 0,
              unread: false
            }
          },
          loadAttackPromise: false
        })

        angular.extend($scope, {
          tag: tag,
          deleteTag: deleteTag,
          exportCsv: exportCsv,
          exportXml: exportXml,
          blacklistIp: blacklistIp,
          suppress: suppress,
          changeTab: changeTab,
          switchTimeline: switchTimeline,
          moveToAttack: moveToAttack,
          markAllMessagesAsRead: markAllMessagesAsRead
        })

        init()

        function init() {
          $scope.model.active = 'summary'
          $scope.busy = true
          $q.all([
            loadAttack(),
            loadTimelineEvents(),
            updateUnreadNotes(),
            _loadTags(),
            _loadNotes()
          ])
            .then(function () {
              $scope.busy = false
            })
            .catch(function (response) {
              $scope.busy = false
              ErrorService.processError(response)
            })
        }

        function markAllMessagesAsRead() {
          AttackFactory.updateLastViewed(attackUuid)
            .then(function () {
              $scope.model.discussionCount.unread = false
            })
            .catch(ErrorService.processError)
        }

        function switchTimeline() {
          $scope.show_timeline = !$scope.show_timeline
        }

        function changeTab(tab) {
          $location.path(
            UserService.buildUrl('/attacks/' + attackUuid + '/overview/' + tab),
            true
          )
        }

        function updateUnreadNotes() {
          return AttackFactory.countUnreadNotes(attackUuid)
            .then(function (response) {
              $scope.model.discussionCount.unread = response.data.unread > 0
            })
            .catch(ErrorService.processError)
        }

        function loadTimelineEvents() {
          $scope.loadTimelineEventsPromise =
            AttackEventsFactory.getTimelineEvents(attackUuid)
              .then(function (response) {
                $scope.timeline = {
                  data: response.data.events,
                  config: {
                    plural: 'events',
                    label2Property: 'eventName',
                    label3Property: 'status',
                    label3ClassAccessor: function (d) {
                      return 'status-' + d.status.toLowerCase()
                    },
                    buildClusterTooltipHtmlAccessor:
                      buildClusterTooltipHtmlAccessor,
                    margin: { left: 60, right: 60, top: 30, bottom: 30 }
                  }
                }
              })
              .catch(ErrorService.processError)

          return $scope.loadTimelineEventsPromise
        }

        function buildClusterTooltipHtmlAccessor(cluster, timeData) {
          var total = cluster.length
          var limit = 10
          var max = total <= limit ? total : limit

          var str =
            '<div class="attack-details-timeline-cluster-point-tooltip">'
          str +=
            '<div class="heading">' +
            total +
            ' Events at ' +
            timeData.timeStr +
            '</div>'
          var clusterItem
          for (var i = 0; i < max; i++) {
            clusterItem = cluster[i]
            str +=
              '<div class="inline-spacing"><span class="event-name">' +
              clusterItem.eventName +
              '</span><span class="event-status ' +
              determineTooltipStatusClass(clusterItem.status) +
              '">' +
              clusterItem.status +
              '</span></div>'
          }
          if (total > max) {
            str += '<div>+' + (total - max) + '</div>'
          }
          return "'" + str + "</div>'"
        }

        function determineTooltipStatusClass(status) {
          status = status.toLowerCase()
          return status
        }

        function loadAttack() {
          var index = AttackSearchService.getIndex(),
            uuids = AttackSearchService.getUUIDs() || []

          $scope.model.index = index
          $scope.model.count = uuids.length
          $scope.model.previous = index > 0 ? uuids[index - 1] : null
          $scope.model.next = index < uuids.length - 1 ? uuids[index + 1] : null

          $scope.loadAttackPromise = AttackFactory.getAttackExpand(
            attackUuid,
            'source_name'
          )
            .then(function (response) {
              var attack = response.data.attack
              $scope.model.attack = attack
              $scope.model.attack.attack_duration =
                attack.attack_duration / 1000
              $scope.model.environments = _.uniq(
                _.map(attack.servers, 'environment')
              )
            })
            .catch(ErrorService.processError)

          return $scope.loadAttackPromise
        }

        function moveToAttack(attackUuid, newIndex) {
          AttackSearchService.setIndex(newIndex)
          $location.path(
            UserService.buildUrl(
              '/attacks/' + attackUuid + '/overview/summary'
            ),
            true
          )
        }

        function exportCsv(attackUuid) {
          var attackObj = []
          attackObj.push({ name: 'attacks', value: attackUuid })

          var data = {
            redirectUrl: UserService.buildAPIUrl('/attacks') + '/export/csv',
            redirectMethod: 'POST',
            redirectData: attackObj
          }

          $rootScope.$broadcast('attack.export', data)
        }

        function tag() {
          var attacks = [$scope.model.attack]
          var modalInstance
          modalInstance = $uibModal.open({
            templateUrl: 'views/tags/modal_tag.html',
            controller: 'ModalTagAttacksCtrl',
            size: 'full',
            resolve: {
              attacks: function () {
                return attacks
              },
              title: function () {
                return 'Tag Attack'
              }
            }
          })

          modalInstance.result.then(function () {
            _loadTags()
          })
        }

        function deleteTag(data) {
          TagFactory.deleteAttackTags(attackUuid, data)
            .then(function (response) {
              $scope.tags = response.data.tags
            })
            .catch(ErrorService.processError)
        }

        function _loadTags() {
          return TagFactory.getAttackTags(attackUuid)
            .then(function (response) {
              $scope.tags = response.data.tags
            })
            .catch(ErrorService.processError)
        }

        function _loadNotes() {
          return AttackFactory.getNotes(attackUuid)
            .then(function (response) {
              $scope.model.discussionCount.total = response.data.notes.length
            })
            .catch(ErrorService.processError)
        }

        function exportXml(attackUuid) {
          var attackObj = []
          attackObj.push({ name: 'attacks', value: attackUuid })

          var data = {
            redirectUrl: UserService.buildAPIUrl('/attacks') + '/export/xml',
            redirectMethod: 'POST',
            redirectData: attackObj
          }

          $rootScope.$broadcast('attack.export', data)
        }

        function blacklistIp(attack) {
          return IPBlacklistModalService.openCreate(attack)
        }

        function suppress(attacks) {
          var suppressSingleAttackUrl = 'views/attacks/suppress_single.tpl.html'
          var suppressSingleUnknownAttackUrl =
            'views/attacks/suppress_single_unknown.tpl.html'
          return csTemplates
            .loadAndInterpolate(
              attacks[0].source === null
                ? suppressSingleUnknownAttackUrl
                : suppressSingleAttackUrl,
              { attackDetailsSource: attacks[0].source }
            )
            .then(function (interpolatedStr) {
              _launchSuppressDialog(attacks, interpolatedStr)
            })
        }

        function _launchSuppressDialog(attacks, msg) {
          return dialogs
            .confirm('Suppress Attack', msg, { size: 'sm', yes: 'Suppress' })
            .result.then(function () {
              _processSuppressResults(AttackFactory.suppressBatch(attacks))
            })
        }

        function _processSuppressResults(promise) {
          return promise
            .then(function () {
              logger.logSuccess('Attack suppressed successfully')
              loadAttack()
            })
            .catch(function (results) {
              var success = 0
              angular.forEach(results, function (result) {
                if (result.status === 200) {
                  success++
                } else {
                  ErrorService.processError(result)
                }
              })

              if (success > 0) {
                logger.logSuccess('Attack suppressed successfully')
              }
            })
        }

        $scope.$on('attack.tab.active', function (event, data) {
          $scope.model.active = data.active
        })

        $scope.$on(ATTACK_DISCUSSION_EVENTS.UPDATE, function () {
          updateUnreadNotes()
        })

        $scope.$on(ATTACK_DISCUSSION_EVENTS.ADD, function () {
          $scope.model.discussionCount.total++
        })

        $scope.$on(ATTACK_DISCUSSION_EVENTS.DELETE, function () {
          $scope.model.discussionCount.total--
        })
      }
    )
})()
